import i18n from 'services/base/i18n';

export default {

  // Type

  typeTitle:    () => i18n.pgettext('Plans|Firewall|Type', 'Pangolin Smart Firewall'),
  typeSubtitle: () => i18n.pgettext('Plans|Firewall|Type', 'Core Device Functionality'),

  // Packages

  packageBasicName: () => i18n.pgettext('Plans|Firewall|Packages', 'Basic'),
  packageBasicInfo: () => i18n.pgettext('Plans|Firewall|Packages', 'Basic smart firewall functionality for homes and small offices'),

  packageBusinessName: () => i18n.pgettext('Plans|Firewall|Packages', 'Business'),
  packageBusinessInfo: () => i18n.pgettext('Plans|Firewall|Packages', 'Better firewall customization for more complex networks'),

  packageEnterpriseName: () => i18n.pgettext('Plans|Firewall|Packages', 'Enterprise'),
  packageEnterpriseInfo: () => i18n.pgettext('Plans|Firewall|Packages', 'Support for enterprise-grade protocols and services'),

  // Billing

  billingMonthlyName: () => i18n.pgettext('Plans|Firewall|Billing', 'Monthly'),
  billingMonthlyInfo: (package_name: string, number_of_months_to_lifetime: number) => i18n.sprintf(
    i18n.pgettext('Plans|Firewall|Billing', 'Billed every month. You will have paid the equivalent amount to a Lifetime subscription for a %1$s Package after %2$s months.'),
    package_name, number_of_months_to_lifetime
  ),
  billingMonthlyPer: () => i18n.pgettext('Plans|Firewall|Billing', 'per month'),

  billingYearlyName: () => i18n.pgettext('Plans|Firewall|Billing', 'Yearly'),
  billingYearlyInfo: (package_name: string, number_of_years_to_lifetime: number) => i18n.sprintf(
    i18n.pgettext('Plans|Firewall|Billing', 'Billed every year. You will have paid the equivalent amount to a Lifetime subscription for a %1$s Package after %2$s years.'),
    package_name, number_of_years_to_lifetime
  ),
  billingYearlyPer: () => i18n.pgettext('Plans|Firewall|Billing', 'per year'),

  billingBiennialName: () => i18n.pgettext('Plans|Firewall|Billing', 'Biennial'),
  billingBiennialInfo: (package_name: string, number_of_years_to_lifetime: number) => i18n.sprintf(
    i18n.pgettext('Plans|Firewall|Billing', 'Billed every two years. You will have paid the equivalent amount to a Lifetime subscription for a %1$s Package after %2$s renewals.'),
    package_name, number_of_years_to_lifetime
  ),
  billingBiennialPer: () => i18n.pgettext('Plans|Firewall|Billing', 'per two years'),

  billingTriennialName: () => i18n.pgettext('Plans|Firewall|Billing', 'Triennial'),
  billingTriennialInfo: (package_name: string, number_of_years_to_lifetime: number) => i18n.sprintf(
    i18n.pgettext('Plans|Firewall|Billing', 'Billed every three years. You will have paid the equivalent amount to a Lifetime subscription for a %1$s Package after %2$s renewals.'),
    package_name, number_of_years_to_lifetime
  ),
  billingTriennialPer: () => i18n.pgettext('Plans|Firewall|Billing', 'per three years'),

  billingLifetimeName: () => i18n.pgettext('Plans|Firewall|Billing', 'Lifetime'),
  billingLifetimeInfo: (package_name: string) => i18n.sprintf(
    i18n.pgettext('Plans|Firewall|Billing', 'One-time payment to own your Pangolin Smart Firewall running a %1$s Package forever.'),
    package_name
  ),
  billingLifetimePer: () => i18n.pgettext('Plans|Firewall|Billing', 'one-time'),

  // Status

  statusActive: () => i18n.pgettext('Plans|Firewall|Status', 'Active'),
  statusPaused: () => i18n.pgettext('Plans|Firewall|Status', 'Paused'),
  statusSuspended: () => i18n.pgettext('Plans|Firewall|Status', 'Suspended'),

  // Stripe

  stripeItemTrialBasic: () => i18n.pgettext('Plans|Firewall|Invoice', 'Trial period for Pangolin Smart Firewall - Basic Plan'),
  stripeItemTrialBusiness: () => i18n.pgettext('Plans|Firewall|Invoice', 'Trial period for Pangolin Smart Firewall - Business Plan'),
  stripeItemTrialEnterprise: () => i18n.pgettext('Plans|Firewall|Invoice', 'Trial period for Pangolin Smart Firewall - Enterprise Plan'),
  stripeItemLifetimeBasic: () => i18n.pgettext('Plans|Firewall|Invoice', 'Pangolin Smart Firewall - Basic Plan'),
  stripeItemLifetimeBusiness: () => i18n.pgettext('Plans|Firewall|Invoice', 'Pangolin Smart Firewall - Business Plan'),
  stripeItemLifetimeEnterprise: () => i18n.pgettext('Plans|Firewall|Invoice', 'Pangolin Smart Firewall - Enterprise Plan'),
  stripeItemMonthlyBasic: (quantity: string, price: string) => i18n.sprintf(
    i18n.pgettext('Plans|Firewall|Invoice', '%s x Pangolin Smart Firewall - Basic Plan (at %s / month)'),
    quantity, price
  ),
  stripeItemMonthlyBusiness: (quantity: string, price: string) => i18n.sprintf(
    i18n.pgettext('Plans|Firewall|Invoice', '%s x Pangolin Smart Firewall - Business Plan (at %s / month)'),
    quantity, price
  ),
  stripeItemMonthlyEnterprise: (quantity: string, price: string) => i18n.sprintf(
    i18n.pgettext('Plans|Firewall|Invoice', '%s x Pangolin Smart Firewall - Enterprise Plan (at %s / month)'),
    quantity, price
  ),
  stripeItemYearlyBasic: (quantity: string, price: string) => i18n.sprintf(
    i18n.pgettext('Plans|Firewall|Invoice', '%s x Pangolin Smart Firewall - Basic Plan (at %s / year)'),
    quantity, price
  ),
  stripeItemYearlyBusiness: (quantity: string, price: string) => i18n.sprintf(
    i18n.pgettext('Plans|Firewall|Invoice', '%s x Pangolin Smart Firewall - Business Plan (at %s / year)'),
    quantity, price
  ),
  stripeItemYearlyEnterprise: (quantity: string, price: string) => i18n.sprintf(
    i18n.pgettext('Plans|Firewall|Invoice', '%s x Pangolin Smart Firewall - Enterprise Plan (at %s / year)'),
    quantity, price
  ),
  stripeItemBiennialBasic: (quantity: string, price: string) => i18n.sprintf(
    i18n.pgettext('Plans|Firewall|Invoice', '%s x Pangolin Smart Firewall - Basic Plan (at %s / 2 years)'),
    quantity, price
  ),
  stripeItemBiennialBusiness: (quantity: string, price: string) => i18n.sprintf(
    i18n.pgettext('Plans|Firewall|Invoice', '%s x Pangolin Smart Firewall - Business Plan (at %s / 2 years)'),
    quantity, price
  ),
  stripeItemBiennialEnterprise: (quantity: string, price: string) => i18n.sprintf(
    i18n.pgettext('Plans|Firewall|Invoice', '%s x Pangolin Smart Firewall - Enterprise Plan (at %s / 2 years)'),
    quantity, price
  ),
  stripeItemTriennialBasic: (quantity: string, price: string) => i18n.sprintf(
    i18n.pgettext('Plans|Firewall|Invoice', '%s x Pangolin Smart Firewall - Basic Plan (at %s / 3 years)'),
    quantity, price
  ),
  stripeItemTriennialBusiness: (quantity: string, price: string) => i18n.sprintf(
    i18n.pgettext('Plans|Firewall|Invoice', '%s x Pangolin Smart Firewall - Business Plan (at %s / 3 years)'),
    quantity, price
  ),
  stripeItemTriennialEnterprise: (quantity: string, price: string) => i18n.sprintf(
    i18n.pgettext('Plans|Firewall|Invoice', '%s x Pangolin Smart Firewall - Enterprise Plan (at %s / 3 years)'),
    quantity, price
  ),
  stripeItemUnusedTimeBasic: (date: string) => i18n.sprintf(
    i18n.pgettext('Plans|Firewall|Invoice', 'Unused time on Pangolin Smart Firewall - Basic Plan after %s'),
    date
  ),
  stripeItemUnusedTimeBusiness: (date: string) => i18n.sprintf(
    i18n.pgettext('Plans|Firewall|Invoice', 'Unused time on Pangolin Smart Firewall - Business Plan after %s'),
    date
  ),
  stripeItemUnusedTimeEnterprise: (date: string) => i18n.sprintf(
    i18n.pgettext('Plans|Firewall|Invoice', 'Unused time on Pangolin Smart Firewall - Enterprise Plan after %s'),
    date
  ),
  stripeItemStripeBalance: () => i18n.pgettext('Plans|Firewall|Invoice', 'Applied from Stripe Balance'),

};
